import { render, staticRenderFns } from "./Newest.vue?vue&type=template&id=55851e98&scoped=true&"
import script from "./Newest.vue?vue&type=script&lang=js&"
export * from "./Newest.vue?vue&type=script&lang=js&"
import style0 from "./Newest.vue?vue&type=style&index=0&id=55851e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55851e98",
  null
  
)

export default component.exports